/** Must match `shell:serve` port — OAuth is proxied to the local mock on :90. */
const LOCAL_SHELL_ORIGIN = 'http://localhost:3001';

export const ENVIRONMENTS = {
  LOCAL: {
    ISSUER: LOCAL_SHELL_ORIGIN,
    AUTHORIZATION_ENDPOINT: `${LOCAL_SHELL_ORIGIN}/oauth/authorize`,
    TOKEN_ENDPOINT: `${LOCAL_SHELL_ORIGIN}/oauth/token`,
    USERINFO_ENDPOINT: `${LOCAL_SHELL_ORIGIN}/oauth/userinfo`,
    REVOCATION_ENDPOINT: `${LOCAL_SHELL_ORIGIN}/oauth/revoke`,
    END_SESSION_ENDPOINT: `${LOCAL_SHELL_ORIGIN}/oauth/logout`,
  },
  STAGING: {
    ISSUER: 'https://stage.id.trimblecloud.com',
    AUTHORIZATION_ENDPOINT: 'https://stage.id.trimblecloud.com/oauth/authorize',
    TOKEN_ENDPOINT: 'https://stage.id.trimblecloud.com/oauth/token',
    USERINFO_ENDPOINT: 'https://stage.id.trimblecloud.com/oauth/userinfo',
    REVOCATION_ENDPOINT: 'https://stage.id.trimblecloud.com/oauth/revoke',
    END_SESSION_ENDPOINT: 'https://stage.id.trimblecloud.com/oauth/logout',
  },
  PRODUCTION: {
    ISSUER: 'https://id.trimble.com',
    AUTHORIZATION_ENDPOINT: 'https://id.trimble.com/oauth/authorize',
    TOKEN_ENDPOINT: 'https://id.trimble.com/oauth/token',
    USERINFO_ENDPOINT: 'https://id.trimble.com/oauth/userinfo',
    REVOCATION_ENDPOINT: 'https://id.trimble.com/oauth/revoke',
    END_SESSION_ENDPOINT: 'https://id.trimble.com/oauth/logout',
  },
} as const;
